import { IGetAlarmDateFiltersProps } from '@interfaces/alarms/alarm';
import { ITableDatepickerFilter } from '@interfaces/components/table';

export const getDateFilters = ({
	onChangeFromDate,
	onChangeToDate,
	startDate,
	endDate,
}: IGetAlarmDateFiltersProps): Array<ITableDatepickerFilter> => {
	return [
		{
			name: 'from',
			label: 'Raised from',
			handleChange: onChangeFromDate,
			selected: startDate,
			disableFutureDates: true,
			maxDate: endDate ? new Date(endDate) : null,
		},
		{
			name: 'to',
			label: 'To',
			handleChange: onChangeToDate,
			selected: endDate,
			disableFutureDates: true,
			minDate: startDate ? new Date(startDate) : null,
		},
	];
};
